import React, { useCallback, useState } from 'react';
import {
  Box,
  Text,
  FormControl,
  TextInput,
  Button,
  ButtonGroup,
  Textarea,
  Checkbox
} from '@primer/react';
import { Dialog } from "@primer/react/drafts";
import { useForm } from 'react-hook-form';
import { useCommonContext } from '../../../../contexts/common';
import { danhSachThiApi } from '../../../../api/danhSachThiApi';
import { NotifyHelper } from '../../../../helpers/toast';

interface CapNhatTrangThaiModalProps {
  is_show_model: boolean;
  ex_danhsachthi_ids: number[];
  onCancel: () => void;
  onSuccess: () => void;
}

interface FormData {
  ex_danhsachthi_ids: number[];
  ghi_chu: string;
  isVangThi: boolean;
}

const CapNhatTrangThaiModal: React.FC<CapNhatTrangThaiModalProps> = ({
  is_show_model,
  ex_danhsachthi_ids,
  onCancel,
  onSuccess
}) => {
  const { translate } = useCommonContext();
  const [formData, setFormData] = useState<FormData>({
    ex_danhsachthi_ids: ex_danhsachthi_ids || [],
    ghi_chu: '',
    isVangThi: false,
  });
  const [isSaving, setIsSaving] = useState(false);
  const { register, trigger, formState: { errors } } = useForm();

  const handleSaveChanges = useCallback(async () => {
    const isValid = await trigger();
    if (isValid) {
      setIsSaving(true);
      try {
        const res = await danhSachThiApi.updateVangThi(formData);
        if (res.is_success) {
          NotifyHelper.Success(translate('Cập nhật trạng thái thành công'));
          onSuccess();
        } else {
          NotifyHelper.Error(res.message || translate('Error.Generic'));
        }
        onCancel();
      } catch (error) {
        NotifyHelper.Error(translate('Error.Generic'));
      }
      setIsSaving(false);
    }
  }, [formData, trigger, onSuccess, onCancel, translate]);

  return (
    <Dialog
      title={translate('Cập nhật trạng thái')}
      onClose={onCancel}
      width="medium"
    >
      <Box as="form" sx={{ p: 0 }}>
        <FormControl sx={{ mb: 3 }}>
          <Box>
            <label>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <input
                  type="checkbox"
                  checked={formData.isVangThi}
                  onChange={(e) => {
                    setFormData(prev => ({
                      ...prev,
                      isVangThi: e.target.checked
                    }));
                    trigger('isVangThi');
                  }}
                />
                <Text>{translate('Vắng thi')}</Text>
              </Box>
            </label>
          </Box>
        </FormControl>

        <FormControl sx={{ mb: 3 }}>
          <FormControl.Label>
            {translate('Ghi chú')}
          </FormControl.Label>
          <Textarea
            value={formData.ghi_chu}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              setFormData(prev => ({
                ...prev,
                ghi_chu: e.target.value
              }));
            }}
            block
            rows={4}
          />
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <ButtonGroup>
            <Button onClick={onCancel}>
              {translate('Base.Label.Cancel')}
            </Button>
            <Button 
              variant="primary"
              onClick={handleSaveChanges}
              disabled={isSaving}
            >
              {translate('Base.Label.Update')}
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CapNhatTrangThaiModal;